import { createContext, useContext, useState, useCallback } from "react";
import { translate } from "@/lib/i18n";

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("pnc_lang") || "de");
  const change = useCallback((l) => {
    localStorage.setItem("pnc_lang", l);
    setLang(l);
  }, []);
  const t = useCallback((key) => translate(lang, key), [lang]);
  return <I18nContext.Provider value={{ lang, setLang: change, t }}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  return useContext(I18nContext);
}
